module.exports = __webpack_public_path__ + "files/8050fd54a0200a1d0c999712bafbbb2b.png";